import { RadioButtonWithLabelGroupWidget, RadioButtonWithLabelOption } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { ExtractTaskType } from '~src/extractTask/serverApi/types/IExtractTask';
import { ExtractServiceRefreshType } from '~src/schedule/serverApi/requests/CreateSelfServiceScheduleExtractTasksRequest';
import { cssClass } from '~src/style';

const cssPrefix = 'PublishedConnectionExtractRefreshTypeOptions';
const paddingBottomClass = cssClass(cssPrefix, 'paddingBottom', {
  paddingBottom: CommonStyles.Sizes.LargeSpace,
});

function createRadioButtonOptions(): RadioButtonWithLabelOption<ExtractServiceRefreshType>[] {
  return [
    {
      value: ExtractTaskType.ExtractServiceFullRefresh as ExtractServiceRefreshType,
      testId: 'published-connection-refresh-type-fuill',
      label: Messages.publishedConnectionTableFullRefreshMessage()
    },
    {
      value: ExtractTaskType.ExtractServiceIncrement as ExtractServiceRefreshType,
      testId: 'published-connection-refresh-type-incremental',
      label: Messages.publishedConnectionTableIncrementalRefreshMessage()
    }
  ];
}

export type PublishedConnectionExtractRefreshTypeOptionsProps = Readonly<{
  selected: ExtractServiceRefreshType;
  onChange: (type: ExtractServiceRefreshType) => void;
}>;

export function PublishedConnectionExtractRefreshTypeOptions(props: PublishedConnectionExtractRefreshTypeOptionsProps): JSX.Element {

  return (
    <RadioButtonWithLabelGroupWidget
      label={Messages.writeOptionsRefreshType()}
      ariaLabel={Messages.publishedConnectionRefreshTypeRadioGroupLabel()}
      buttonList={createRadioButtonOptions()}
      className={paddingBottomClass}
      checkedIndex={props.selected === ExtractTaskType.ExtractServiceFullRefresh ? 0 : 1}
      handleChange={props.onChange}
    />
  );
}
